module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzIxOTZGMyIgZD0iTTM3IDQwSDExbC02IDZWMTJjMC0zLjMgMi43LTYgNi02aDI2YzMuMyAwIDYgMi43IDYgNnYyMmMwIDMuMy0yLjcgNi02IDZ6Ii8+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTIyIDIwaDR2MTFoLTR6Ii8+PGNpcmNsZSBjeD0iMjQiIGN5PSIxNSIgcj0iMiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/about_me.svg
// module id = 4166
// module chunks = 0